import Link from "@mui/material/Link";
import { useTranslate } from "hooks/useTranslate";
import { useAppDispatch } from "redux/hooks";
import { checkUserAccess } from "utils/CommonFunctions";
import { setFeedbackDetails } from "./Snackbar/snackbar.slice";

interface Prop {
  text: string | React.ReactNode;
  textVariant: any;
  onClick?: any;
  underline?: "always" | "hover" | "none";
  sx?: any;
  type?: string;
  accessType?: string;
  showBold?: boolean;
}

export default function ButtonLink(props: Prop) {
  const { text, textVariant, onClick, sx, underline = "always", type = "button", accessType, showBold = false } = props;
  const restrictAccess = accessType && !checkUserAccess(accessType);
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const handleClick = (event: any) => {
    if (restrictAccess)
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("user.restrictAccess")
        })
      );
    else if (onClick) onClick(event);
  };
  return (
    <Link
      component="button"
      variant={textVariant}
      underline={underline}
      onClick={handleClick}
      type={type}
      sx={{ fontWeight: showBold ? 700 : 400, ...sx }}
    >
      {text}
    </Link>
  );
}
